module.exports = __webpack_public_path__ + "img/banner_left.ba298758.jpg";